import { render } from "./MdListList.vue?vue&type=template&id=4920fe24&scoped=true"
import script from "./MdListList.vue?vue&type=script&lang=js"
export * from "./MdListList.vue?vue&type=script&lang=js"

import "./MdListList.vue?vue&type=style&index=0&id=4920fe24&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4920fe24"]])

export default __exports__